import React from "react";
import axios from "axios";
import { Container, Row, Col } from "shards-react";
import PageTitle from "../../../components/common/PageTitle";
import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

import api from "../../common/api";

import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import Chip from "@material-ui/core/Chip";

import { withStyles } from "@material-ui/styles";
import Backdrop from "@material-ui/core/Backdrop";
import InfoAuto from "../InfoAuto/InfoAuto";

const styles = theme => ({
  SwitchLabel: {
    "& .MuiFormControlLabel-label": {
      fontSize: "0.75rem"
    }
  },
  formControl: {
    margin: 10,
    minWidth: 150,
    fontSize: "0.75rem"
  },
  typography: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: 0,
    fontSize: "1rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: "translate(0, 1.5px) scale(0.75)",
    transformOrigin: "top left",
    letterSpacing: "0.00938em",
    transition:
      "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
  }
});

const ITEM_HEIGHT = 48;

const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

class ModelsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      loading: true,
      errors: false,
      backdrop: false,
      action: "new",
      model: {
        brand_id: "",
        dnrpa_code: "",
        dnrpa_description: "",
        aldnet_code: "",
        aldnet_description: "",
        model_description: "",
        name: "",
        is_imported: ""
      },
      version: {
        vehicle_type_id: "",
        renting_description: "",
        combustion_type_id: "",
        gama_id: "",
        transmition_type_id: "",
        carbon_footprint: "",
        tank_capacity: "",
        maintenance_plan_id: "",
        maintenance_plans: [],
        maintenance_plans_remove: []
      },
      gamas: [],
      models: [],
      transmition_types: [],
      combustion_types: [],
      vehicle_types: [],
      brands: [],
      maintenance_plans: []
    };
  }
  async componentDidMount() {
    var params = this.getParams();
    var brand_id = params.brand_id;
    var id = params.id;
    var view = params.view;
    await this.getMaintenancePlans();
    this.getBrands();
    await this.setParams();
    if (parseInt(id) !== 0) {
      this.getModel(id);
      if (view !== undefined) {
        this.setState({ disabled: true, action: "view" });
      } else {
        this.setState({ action: "edit" });
      }
    } else {
      if (brand_id === 0) {
        brand_id = "";
      }
      this.setState({
        action: "new",
        model: {
          brand_id: brand_id,
          dnrpa_code: "",
          dnrpa_description: "",
          aldnet_code: "",
          aldnet_description: "",
          model_description: "",
          name: "",
          is_imported: ""
        }
      });
    }
  }
  getParams() {
    return this.props.match.params;
  }

  async getBrands() {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.brands().index(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        res.data = Object.values(res.data);
        this.setState({ brands: res.data, loading: false });
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  }

  async getMaintenancePlans() {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.maintenance_plans().index(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        res.data = Object.values(res.data);
        this.setState({ maintenance_plans: res.data });
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  }

  getModel(id) {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.versions().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        res.data = Object.values(res.data);
        var model = res.data[0];
        model.brand_id = res.data[0].brand_id;
        var version = res.data[0].versions.filter(
          version => parseInt(version.id) === parseInt(id)
        );
        version[0].maintenance_plans = [];
        version[0].maintenance_plans_remove = [];
        version[0].maintenance_plan_id = version[0].maintenance_plan_version[0]
          ? version[0].maintenance_plan_version[0].maintenance_plan_id
          : "";
        version[0].maintenance_plan_version.map((val, idx) => {
          version[0].maintenance_plans.push(val.maintenance_plan.name);
        });
        this.setState({ version: version[0] });
        this.setState({ model: model });
        this.setState({ brand_id: res.data[0].brand_id });
        this.setState({ loading: false });
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  }

  async setParams() {
    const token = localStorage.getItem("userToken");
    var results = await axios
      .all([
        axios.get(api.gamas, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(api.vehicle_types, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.transmition_types, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.combustion_types, {
          headers: { Authorization: `Bearer ${token}` }
        })
      ])
      .then(
        axios.spread((...responses) => {
          const gamas = responses[0].data;
          const vehicle_types = responses[1].data;
          const transmition_types = responses[2].data;
          const combustion_types = responses[3].data;
          this.setState({
            gamas,
            vehicle_types,
            transmition_types,
            combustion_types
          });
        })
      );
  }

  handleCodiaChange = codia => {
    var version = this.state.version;
    version.infoauto_codia = codia;
    this.setState({ version: version });
  };

  handleChange = event => {
    event.preventDefault();
    var key = event.target.name;
    var value = event.target.value;
    var model = this.state.model;
    var version = this.state.version;
    if (
      [
        "vehicle_type_id",
        "renting_description",
        "combustion_type_id",
        "gama_id",
        "transmition_type_id",
        "carbon_footprint",
        "dnrpa_code",
        "dnrpa_type_description",
        "dnrpa_fullcode",
        "tank_capacity",
        "name",
        "maintenance_plan_id",
        "default_months_warranty",
        "default_km_warranty",
        "maintenance_plans"
      ].includes(key)
    ) {
      version[key] = value;
      if (key === "vehicle_type_id") {
        var vehicle_type = this.state.vehicle_types.filter(
          type => parseInt(type.id) === parseInt(value)
        );
        version["renting_description"] = vehicle_type[0].hansa_description;
      }
      this.setState({ version: version });
    } else {
      if (key === "is_imported") {
        if (value === "true") {
          value = false;
        } else {
          value = true;
        }
      }
      model[key] = value;
      this.setState({ model: model });
    }
  };
  handleCloseBackdrop = () => {
    var backdrop = !this.state.backdrop;
    this.setState({ backdrop: backdrop });
  };

  handleSubmit = event => {
    this.setState({ backdrop: true });
    event.preventDefault();
    event.stopPropagation();
    var formData = new FormData();
    formData.set("variation[brand_id]", this.state.model.brand_id);
    formData.set(
      "variation[name]",
      this.state.model.model_description
        ? this.state.model.model_description.toUpperCase()
        : ""
    );
    formData.set(
      "variation[model_description]",
      this.state.model.model_description
        ? this.state.model.model_description.toUpperCase()
        : ""
    );
    formData.set(
      "variation[dnrpa_description]",
      this.state.model.dnrpa_description
        ? this.state.model.dnrpa_description.toUpperCase()
        : ""
    );
    formData.set(
      "variation[aldnet_code]",
      this.state.model.aldnet_code
        ? this.state.model.aldnet_code.toUpperCase()
        : ""
    );
    formData.set(
      "variation[aldnet_description]",
      this.state.model.aldnet_description
        ? this.state.model.aldnet_description.toUpperCase()
        : ""
    );
    formData.set(
      "variation[is_imported]",
      this.state.model.is_imported ? 1 : 0
    ); // );
    formData.set(
      "version[dnrpa_code]",
      this.state.version.dnrpa_code
        ? this.state.version.dnrpa_code.toUpperCase()
        : ""
    );
    formData.set(
      "version[dnrpa_fullcode]",
      this.state.version.dnrpa_fullcode
        ? this.state.version.dnrpa_fullcode.toUpperCase()
        : ""
    );
    formData.set(
      "version[dnrpa_type_description]",
      this.state.version.dnrpa_type_description
        ? this.state.version.dnrpa_type_description.toUpperCase()
        : ""
    );
    formData.set(
      "version[name]",
      this.state.version.name ? this.state.version.name.toUpperCase() : ""
    );
    formData.set(
      "version[combustion_type_id]",
      this.state.version.combustion_type_id
    );
    formData.set(
      "version[transmition_type_id]",
      this.state.version.transmition_type_id
    );
    formData.set("version[gama_id]", this.state.version.gama_id);
    formData.set(
      "version[vehicle_type_id]",
      this.state.version.vehicle_type_id
    );
    formData.set("version[tank_capacity]", this.state.version.tank_capacity);
    formData.set(
      "version[carbon_footprint]",
      this.state.version.carbon_footprint
        ? this.state.version.carbon_footprint
        : ""
    );
    formData.set(
      "version[renting_description]",
      this.state.version.renting_description
    );
    //formData.set("version[maintenance_plan_id]", this.state.version.maintenance_plan_id);
    formData.set(
      "version[default_months_warranty]",
      this.state.version.default_months_warranty
        ? this.state.version.default_months_warranty
        : ""
    );
    formData.set(
      "version[default_km_warranty]",
      this.state.version.default_km_warranty
        ? this.state.version.default_km_warranty
        : ""
    );
    formData.set(
      "version[infoauto_codia]",
      this.state.version.infoauto_codia ? this.state.version.infoauto_codia : ""
    );
    var i = 0;
    this.state.version.maintenance_plans.map((val, idx) => {
      var maintenance_plan = this.state.maintenance_plans.filter(
        maintenance_plan => maintenance_plan.name === val
      );
      if (maintenance_plan[0]) {
        formData.set(
          "version[maintenance_plans][" + i + "][maintenance_plan_id]",
          maintenance_plan[0].id
        );
        i++;
      }
    });
    this.state.version.maintenance_plans_remove.map((val, idx) => {
      var maintenance_plan = this.state.maintenance_plans.filter(
        maintenance_plan => maintenance_plan.name === val
      );
      if (maintenance_plan[0]) {
        formData.set(
          "version[maintenance_plans][" + i + "][maintenance_plan_id]",
          maintenance_plan[0].id
        );
        formData.set("version[maintenance_plans][" + i + "][deleted_at]", 1);
        i++;
      }
    });

    let self = this;
    const token = localStorage.getItem("userToken");
    if (this.state.action === "new") {
      axios
        .post(api.models().post(), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          self.setState({ errors: false, save_model: true });
          self.setState({ message: "Modelo creado con éxito!" });
          self.setState({ dialogOpen: true });
          self.handleCloseBackdrop();
        })
        .catch(function(error) {
          self.setState({ errors: true });
          self.setState({
            message:
              "Hubo un problema al guardar el modelo. Por favor volver a intentar"
          });
          self.setState({ dialogOpen: true });
          self.handleCloseBackdrop();
        });
    } else {
      formData.set("variation[id]", this.state.model.id);
      formData.set("version[id]", this.state.version.id);
      formData.append("_method", "patch");
      axios
        .post(api.models().patch(this.state.model.id), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          self.setState({ errors: false, save_model: true });
          self.setState({ message: "Modelo modificado con éxito!" });
          self.setState({ dialogOpen: true });
          self.handleCloseBackdrop();
        })
        .catch(function(error) {
          self.setState({ errors: true, save_model: false });
          self.setState({
            message:
              "Hubo un problema al guardar el modelo. Por favor volver a intentar"
          });
          self.setState({ dialogOpen: true });
          self.handleCloseBackdrop();
        });
    }
  };

  removeMaintenancePlan = maintenance_plan => {
    var version = this.state.version;
    version.maintenance_plans = version.maintenance_plans.filter(
      maintenance_plan_version => maintenance_plan_version !== maintenance_plan
    );
    version.maintenance_plans_remove.push(maintenance_plan);
    this.setState({ version: version });
  };
  render() {
    const handleRedirect = id => () => {
      window.location.href = `/models/0`;
    };

    const handleDialogClose = () => {
      this.setState({ dialogOpen: false });
    };
    const { classes } = this.props;
    const disabled = this.state.disabled;
    const { model, version } = this.state;
    const {
      vehicle_types,
      gamas,
      transmition_types,
      combustion_types,
      brands,
      maintenance_plans
    } = this.state;
    return (
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header pt-4">
          <PageTitle sm="4" title={"Modelos"} className="text-sm-left" />
        </Row>
        <Row>
          <Col md="12">
            <React.Fragment>
              {this.state.dialogOpen ? (
                <Dialog
                  open={this.state.dialogOpen}
                  fullWidth
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle id="responsive-dialog-title">
                    {"Modelos"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>{this.state.message}</DialogContentText>
                  </DialogContent>
                  <DialogActions disableSpacing="false">
                    {this.state.save_model ? (
                      <Button
                        onClick={handleRedirect()}
                        variant="contained"
                        color="primary"
                      >
                        Aceptar
                      </Button>
                    ) : (
                      ""
                    )}
                    {this.state.errors ? (
                      <Button
                        onClick={handleDialogClose}
                        variant="contained"
                        color="primary"
                      >
                        Aceptar
                      </Button>
                    ) : (
                      ""
                    )}
                  </DialogActions>
                </Dialog>
              ) : (
                ""
              )}
              {this.state.loading ? (
                <LinearProgress />
              ) : (
                <div>
                  <form onSubmit={this.handleSubmit}>
                    <div className="row ml-1">
                      <FormControl
                        className="mt-3 mr-2"
                        style={{ minWidth: 150, fontSize: "0.75rem" }}
                        name="brand_id"
                      >
                        <Typography className={classes.typography}>
                          Marca
                        </Typography>
                        <Select
                          native
                          name="brand_id"
                          inputProps={{
                            name: "brand_id",
                            className: "brand_id"
                          }}
                          style={{ minWidth: 150, fontSize: "0.75rem" }}
                          disabled={disabled}
                          onChange={this.handleChange}
                          required
                          value={model.brand_id}
                          input={
                            <Input id="grouped-native-select" name="brand_id" />
                          }
                        >
                          <option value="" />
                          {brands.map(brand => (
                            <option id={brand.id} value={brand.id}>
                              {brand.name}
                            </option>
                          ))}
                        </Select>
                      </FormControl>

                      <TextField
                        id="dnrpa_code"
                        name="dnrpa_code"
                        label="Código DNRPA Version"
                        disabled={disabled}
                        type="text"
                        required
                        placeholder="Ingrese el código de DNRPA"
                        onChange={this.handleChange}
                        value={version.dnrpa_code}
                        margin="normal"
                        className="mr-2 "
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          style: { minWidth: 200, fontSize: "0.75rem" }
                        }}
                      />
                      <TextField
                        id="dnrpa_fullcode"
                        name="dnrpa_fullcode"
                        label="Código DNRPA Completo"
                        disabled={disabled}
                        type="text"
                        required
                        placeholder="Ingrese el código completo de DNRPA"
                        onChange={this.handleChange}
                        value={version.dnrpa_fullcode}
                        margin="normal"
                        className="mr-2 "
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          style: { minWidth: 200, fontSize: "0.75rem" }
                        }}
                      />
                      <TextField
                        id="dnrpa_description"
                        name="dnrpa_description"
                        label="Modelo DNRPA"
                        disabled={disabled}
                        type="text"
                        required
                        placeholder="Ingrese el descripción de DNRPA"
                        onChange={this.handleChange}
                        value={model.dnrpa_description}
                        margin="normal"
                        className="mr-2 "
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          style: { minWidth: 200, fontSize: "0.75rem" }
                        }}
                      />
                      <TextField
                        id="model_description"
                        name="model_description"
                        label="Modelo"
                        disabled={disabled}
                        type="text"
                        required
                        placeholder="Ingrese el modelo"
                        onChange={this.handleChange}
                        value={model.model_description}
                        margin="normal"
                        className="mr-2 "
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          style: { minWidth: 200, fontSize: "0.75rem" }
                        }}
                      />
                      <TextField
                        id="name"
                        name="name"
                        label="Versión"
                        disabled={disabled}
                        type="text"
                        required
                        placeholder="Ingrese la versión"
                        onChange={this.handleChange}
                        value={version.name}
                        margin="normal"
                        className="mr-2 "
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          style: { minWidth: 200, fontSize: "0.75rem" }
                        }}
                      />
                      <TextField
                        id="dnrpa_type_description"
                        name="dnrpa_type_description"
                        label="DNRPA Tipo Vehiculo"
                        disabled={disabled}
                        type="text"
                        required
                        placeholder="Ingrese el tipo de vehiculo"
                        onChange={this.handleChange}
                        value={version.dnrpa_type_description}
                        margin="normal"
                        className="mr-2 "
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          style: { minWidth: 200, fontSize: "0.75rem" }
                        }}
                      />
                    </div>
                    <div className="row ml-1">
                      <TextField
                        id="aldnet_code"
                        name="aldnet_code"
                        label="Código ALDNET"
                        disabled={disabled}
                        type="text"
                        placeholder="Ingrese el código de ALDNET"
                        onChange={this.handleChange}
                        value={model.aldnet_code}
                        margin="normal"
                        className="mr-2 "
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          style: { minWidth: 200, fontSize: "0.75rem" }
                        }}
                      />
                      <TextField
                        id="aldnet_description"
                        name="aldnet_description"
                        label="Descripción ALDNET"
                        disabled={disabled}
                        type="text"
                        placeholder="Ingrese el descripción de ALDNET"
                        onChange={this.handleChange}
                        value={model.aldnet_description}
                        margin="normal"
                        className="mr-2 "
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          style: { minWidth: 200, fontSize: "0.75rem" }
                        }}
                      />
                      <FormControl
                        className="mt-3 mr-2"
                        style={{ minWidth: 150, fontSize: "0.75rem" }}
                        name="vehicle_type_id"
                      >
                        <Typography className={classes.typography}>
                          Tipo de vehiculo
                        </Typography>
                        <Select
                          native
                          name="vehicle_type_id"
                          inputProps={{
                            name: "vehicle_type_id",
                            className: "vehicle_type_id"
                          }}
                          style={{ minWidth: 150, fontSize: "0.75rem" }}
                          disabled={disabled}
                          onChange={this.handleChange}
                          required
                          value={version.vehicle_type_id}
                          input={
                            <Input
                              id="grouped-native-select"
                              name="vehicle_type_id"
                            />
                          }
                        >
                          <option value="" />
                          {vehicle_types.map(vehicle_type => (
                            <option
                              id={vehicle_type.id}
                              value={vehicle_type.id}
                            >
                              {vehicle_type.hansa_code} - {vehicle_type.name}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                      <TextField
                        id="renting_description"
                        name="renting_description"
                        label="Desc. renting"
                        disabled={disabled}
                        type="text"
                        required
                        placeholder="Ingrese la descripción de renting"
                        onChange={this.handleChange}
                        value={version.renting_description}
                        margin="normal"
                        className="mr-2 "
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          style: { minWidth: 200, fontSize: "0.75rem" }
                        }}
                      />
                    </div>
                    <div className="row ml-1">
                      {/*<FormControl className="mt-3 mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='maintenance_plan_id' >
								<Typography className={classes.typography}>Plan de Mantenimiento</Typography>
								<Select native name='maintenance_plan_id'
								    inputProps={{
								      name:"maintenance_plan_id",
								      className:"maintenance_plan_id"
								    }}
								    style={{minWidth: 150, fontSize: '0.75rem'}}
								    disabled={disabled}
								    onChange={this.handleChange}
								    required
								    value={version.maintenance_plan_id}
								    input={<Input id="grouped-native-select" name='maintenance_plan_id'/>}>
								    <option value="" />
								    	{maintenance_plans.map((maintenance_plan) => <option id={maintenance_plan.id} value={maintenance_plan.id}>{maintenance_plan.name}
								  </option>)}
								</Select>
							</FormControl>*/}

                      <FormControl
                        className="mr-2"
                        style={{
                          minWidth: 170,
                          fontSize: "0.75rem",
                          marginTop: "11px"
                        }}
                      >
                        <Typography className={classes.typography}>
                          Plan de Mantenimiento
                        </Typography>
                        <Select
                          labelId="demo-mutiple-chip-label"
                          id="maintenance_plans"
                          name="maintenance_plans"
                          multiple
                          disabled={disabled}
                          value={version.maintenance_plans}
                          onChange={this.handleChange}
                          input={<Input id="select-multiple-chip" />}
                          renderValue={selected => (
                            <div className={classes.chips}>
                              {selected.map(value => (
                                <Chip
                                  key={value}
                                  label={value}
                                  className={classes.chip}
                                  clickeable={true}
                                  onDelete={e => {
                                    this.removeMaintenancePlan(value);
                                  }}
                                  onMouseDown={e => {
                                    e.stopPropagation();
                                  }}
                                />
                              ))}
                            </div>
                          )}
                          MenuProps={MenuProps}
                        >
                          {maintenance_plans.map(maintenance_plan => (
                            <MenuItem
                              key={maintenance_plan.id}
                              value={maintenance_plan.name}
                              style={{ fontSize: "0.75rem" }}
                            >
                              <Checkbox
                                className="pr-4"
                                color="primary"
                                checked={
                                  version.maintenance_plans.indexOf(
                                    maintenance_plan.name
                                  ) > -1
                                }
                                style={{ height: 0, width: 0 }}
                              />
                              {maintenance_plan.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <FormControl
                        className="mt-3 mr-2"
                        style={{ minWidth: 150, fontSize: "0.75rem" }}
                        name="gama_id"
                      >
                        <Typography className={classes.typography}>
                          Clasificación huella CO2
                        </Typography>
                        <Select
                          native
                          name="gama_id"
                          inputProps={{
                            name: "gama_id",
                            className: "gama_id"
                          }}
                          style={{ minWidth: 150, fontSize: "0.75rem" }}
                          disabled={disabled}
                          onChange={this.handleChange}
                          required
                          value={version.gama_id}
                          input={
                            <Input
                              id="grouped-native-select"
                              name="provider_type_id"
                            />
                          }
                        >
                          <option value="" />
                          {gamas.map(gama => (
                            <option id={gama.id} value={gama.id}>
                              {gama.name}
                            </option>
                          ))}
                        </Select>
                      </FormControl>

                      <FormControl
                        className="mt-3 mr-2"
                        style={{ minWidth: 150, fontSize: "0.75rem" }}
                        name="combustion_type_id"
                      >
                        <Typography className={classes.typography}>
                          Tipo de combustión
                        </Typography>
                        <Select
                          native
                          name="combustion_type_id"
                          inputProps={{
                            name: "combustion_type_id",
                            className: "combustion_type_id"
                          }}
                          style={{ minWidth: 150, fontSize: "0.75rem" }}
                          disabled={disabled}
                          onChange={this.handleChange}
                          required
                          value={version.combustion_type_id}
                          input={
                            <Input
                              id="grouped-native-select"
                              name="combustion_type_id"
                            />
                          }
                        >
                          <option value="" />
                          {combustion_types.map(combustion_type => (
                            <option
                              id={combustion_type.id}
                              value={combustion_type.id}
                            >
                              {combustion_type.name}
                            </option>
                          ))}
                        </Select>
                      </FormControl>

                      <FormControl
                        className="mt-3 mr-2"
                        style={{ minWidth: 150, fontSize: "0.75rem" }}
                        name="transmition_type_id"
                      >
                        <Typography className={classes.typography}>
                          Transmisión
                        </Typography>
                        <Select
                          native
                          name="transmition_type_id"
                          inputProps={{
                            name: "transmition_type_id",
                            className: "transmition_type_id"
                          }}
                          style={{ minWidth: 150, fontSize: "0.75rem" }}
                          disabled={disabled}
                          onChange={this.handleChange}
                          required
                          value={version.transmition_type_id}
                          input={
                            <Input
                              id="grouped-native-select"
                              name="transmition_type_id"
                            />
                          }
                        >
                          <option value="" />
                          {transmition_types.map(trasmition_type => (
                            <option
                              id={trasmition_type.id}
                              value={trasmition_type.id}
                            >
                              {trasmition_type.name}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    <div className="row ml-1">
                      <TextField
                        disabled={disabled}
                        id="default_km_warranty"
                        name="default_km_warranty"
                        type="number"
                        label="KM Garantía"
                        placeholder="Ingrese el km hasta de garantía"
                        onChange={this.handleChange}
                        value={version.default_km_warranty}
                        margin="normal"
                        className="mr-2 "
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          min: "0",
                          style: { minWidth: 200, fontSize: "0.75rem" }
                        }}
                      />
                      <TextField
                        disabled={disabled}
                        id="default_months_warranty"
                        name="default_months_warranty"
                        type="number"
                        label="Meses Garantía"
                        placeholder="Ingrese los meses hasta de garantía"
                        onChange={this.handleChange}
                        value={version.default_months_warranty}
                        margin="normal"
                        className="mr-2 "
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          min: "0",
                          style: { minWidth: 200, fontSize: "0.75rem" }
                        }}
                      />
                    </div>

                    <div className="row ml-1">
                      <TextField
                        disabled={disabled}
                        id="tank_capacity"
                        name="tank_capacity"
                        type="number"
                        label="Capacidad del tanque"
                        placeholder="Ingrese la capacidad del tanque"
                        onChange={this.handleChange}
                        value={version.tank_capacity}
                        margin="normal"
                        className="mr-2 "
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          min: "0",
                          style: { minWidth: 200, fontSize: "0.75rem" }
                        }}
                      />
                      <TextField
                        disabled={disabled}
                        id="carbon_footprint"
                        name="carbon_footprint"
                        type="number"
                        label="Huella de carbono "
                        placeholder="Ingrese la huella de carbono"
                        onChange={this.handleChange}
                        value={version.carbon_footprint}
                        margin="normal"
                        className="mr-2 "
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          min: "0",
                          style: { minWidth: 200, fontSize: "0.75rem" }
                        }}
                      />
                      <FormControlLabel
                        className={classes.SwitchLabel}
                        control={
                          <Switch
                            id="is_imported"
                            value={model.is_imported}
                            checked={model.is_imported}
                            disabled={disabled}
                            onChange={this.handleChange}
                            name="is_imported"
                            size="small"
                            color="primary"
                            className="mr-4"
                          />
                        }
                        label="Es importado?"
                        labelPlacement="top"
                      />
                    </div>
                    <InfoAuto
                      onCodiaSelected={this.handleCodiaChange}
                      variation={model}
                      version={version}
                    />
                    {this.state.action !== "view" ? (
                      <React.Fragment>
                        <Button
                          type="submit"
                          variant="contained"
                          className="mt-3 ml-1 mr-1"
                          color="primary"
                        >
                          Guardar
                        </Button>
                        <Button
                          variant="contained"
                          className="mt-3 ml-1 mr-1"
                          color="secondary"
                          href={"/models/" + this.state.brand_id}
                        >
                          Cancelar
                        </Button>
                      </React.Fragment>
                    ) : (
                      <Button
                        variant="contained"
                        className="mt-3 ml-1 mr-1"
                        color="secondary"
                        href={"/models/" + this.state.brand_id}
                      >
                        Volver
                      </Button>
                    )}
                  </form>
                </div>
              )}
            </React.Fragment>
          </Col>
        </Row>
        <React.Fragment>
          <Backdrop
            open={this.state.backdrop}
            onClick={this.handleCloseBackdrop}
            style={{ zIndex: 10000, color: "#3f51b5" }}
          >
            <Typography className="ml-2" variant="h5" color="primary">
              Guardando...
            </Typography>
          </Backdrop>
        </React.Fragment>
      </Container>
    );
  }
}

export default withStyles(styles)(ModelsForm);
